import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, bmRequest, bmRequestStatusHistroy } from '../../../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster } from '../../../models/admin';
import { outgoingBMRequest } from '../../../models/slakpi';
import { UtilityService } from '../../../services/utility.service';
import { BMApiService } from '../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from '../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../services/admin.service';
import { ToasterService } from '../../../toaster.service';
import { RSAHelper } from '../../../models/RSAHelper';

@Component({
  selector: 'app-bm-request-master',
  templateUrl: './bm-request-master.component.html',
  styleUrls: ['./bm-request-master.component.css']
})
export class BMRequestMasterComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('requestStatusUpdateTemplate', { static: false }) requestStatusUpdateTemplate: TemplateRef<any>;
  @ViewChild('requestStatusUpdateHistroyTemplate', { static: false }) requestStatusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  histroyColumnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  objOutgoingRequest: any = new outgoingBMRequest();
  objBMRequest: any = new bmRequest();
  objStatusHistroy: any = new bmRequestStatusHistroy();
  angularGrid: AngularGridInstance;
  bmProgressMasterData: object[];
  selected_itemUno: number = 0;
  pfmType: any;
  isTitle: boolean = false;
  continentDDList: any = [];
  isContinentDD: boolean = false;
  titleName: string;
  Title2: boolean;
  countryDDList: any;
  isCountryDD: boolean = false;
  isRegionDD: boolean = false;
  sourceTypeDDList: any = [];
  regionDDList: any = [];
  isSourceTypeDD: boolean = false;
  isSourceDesc: boolean = false;
  utilityTypeDDList: any = [];
  peerTypeDDList: any = [];
  isUtilityTypeDD = false;
  isPeerTypeDD = false;
  isBusinessModel: boolean = false;
  isTechnologyUsed: boolean = false;
    bmProgressTypeDDList: Object;
    division_data: Object;
  department_data: Object;
  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Awaiting Approval' }, { value: 3, text: 'Approved' }, { value: 4, text: 'On Hold' }, { value: 5, text: 'Rejected' }];
  userList: any;
    login_UserID: any;
    editID: any;
    searchText: string;
    dataHistroy: any;
  bmRequestStatusHistroyDataSet: any[];
  user: any = {};
  isAdmin: boolean;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    tenantUno: any;
  constructor(private formBuilder: FormBuilder, public restApi: AdminApiService,
    public restBMApi: BMApiService,private route: ActivatedRoute,
    public utilityService: UtilityService, private router: Router, private toaster: ToasterService, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public RASHelper: RSAHelper) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("BM Request");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.searchText = '';
    this.loadBMRequestMaster();
   

  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {
        
        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }
  


  setGridBMRequestMasterDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'topic', name: 'Topic', field: 'topic', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'topic', 'topic'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'typeDescr', name: 'Type Description', field: 'typeDescr', sortable: true, type: FieldType.string, filterable: true, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'typeDescr', 'typeDescr'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'reasonforBMSel', name: 'Reason for BM Sel', field: 'reasonforBMSel', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reasonforBMSel', 'reasonforBMSel'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'impactArea', name: 'Impact Area', field: 'impactArea', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'impactArea', 'impactArea'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'targetPeerGeoArea', name: 'Target Peer Geo Area', field: 'targetPeerGeoArea', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetPeerGeoArea', 'targetPeerGeoArea'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'targetBMIndtry', name: 'Target BM Industry', field: 'targetBMIndtry', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetBMIndtry', 'targetBMIndtry'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'expectedOutcomes', name: 'Expected Outcomes', field: 'expectedOutcomes', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'expectedOutcomes', 'expectedOutcomes'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 20,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.status == 'Approved')
            return '<span  class="status-area status-green">Approved</span>';
          else if (data.status == 'Awaiting Approval')
            return '<span  class="status-area status-orange">Awaiting Approval</span>';
          else if (data.status == 'On Hold')
            return '<span  class="status-area status-yellow">On Hold</span>';
          else if (data.status == 'Rejected')
            return '<span  class="status-area status-red">Rejected</span>';
          else if (data.status == 'Draft')
            return '<span  class="status-area status-gray">Draft</span>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 20,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;

                this.objBMRequest = rdata;
                this.selTab = true;

              

                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objStatusHistroy.status = rdata.status;
                this.objStatusHistroy.comments = '';



                if (this.pageAction == 'edit') {
                  
                  this.selected_itemUno = rdata.id;
                }
                this.modalRef = this.modalService.show(
                  this.requestStatusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMRequestStatusHistroy();
                this.objStatusHistroy.comments = '';
                this.modalRef = this.modalService.show(
                  this.requestStatusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteBMRequestMaster(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }
  setGridBMRequestStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 100,
        filter: {
          collection: this.uniqueArray(this.dataset, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'createdBy', name: 'Action By', field: 'createdBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },
      
      
      {
        id: 'enteredOn', name: 'Action Date', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataset, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },
    

    ]


  }
 
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  loadBMRequestMaster() {
    this.spinner.show();
    let inpValue = new bmRequest();
    inpValue.languageUno = 1033;
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restBMApi.getBMRequestMaster(inpValue)
      .subscribe(data => {
        

        this.data = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
         
            mockDataset[i] = {
              id: this.data[i].id,
              incidentNo: this.data[i].incidentNo,
              prNumber: this.data[i].prNumber,
              topic: this.data[i].topic,
              typeDescr: this.data[i].typeDescr,
              reasonforBMSel: this.data[i].reasonforBMSel,
              impactArea: this.data[i].impactArea,
              targetPeerGeoArea: this.data[i].targetPeerGeoArea,
              targetBMIndtry: this.data[i].targetBMIndtry,
              expectedOutcomes: this.data[i].expectedOutcomes,
              comments: this.data[i].comments,
              ownerPRNumber: this.data[i].ownerPRNumber,
              status: this.data[i].status,
              enteredBy: this.data[i].enteredBy,
              enteredOn: this.data[i].enteredOn,

            };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMRequestMasterDefn();
        }
        else {
          this.setGridBMRequestMasterDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  loadBMRequestStatusHistroy() {
    this.spinner.show();
    let inpValue = new bmRequestStatusHistroy();
    inpValue.flag = 'bmrequest';
    inpValue.id = (this.editID) ?this.editID:0;
    inpValue.userUno = this.login_UserID;

    this.restBMApi.getBMRequestStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            reqNo: this.dataHistroy[i].reqNo,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.bmRequestStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMRequestStatusHistroyDefn();
        }
        else {
          this.setGridBMRequestStatusHistroyDefn();
        }
       
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  openModalWithClass(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "add";
    this.objBMRequest = new bmRequest();

    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  onSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.AddEditBMRequestMaster(this.objBMRequest)
    }
  }

  AddEditBMRequestMaster(data1: any) {
    
   
    //if (this.DuplicateNameCheck(this.utilityService.isNumericNull(data1.id), this.utilityService.isStringNull(data1.bmProgressName), '')) {
    //  Swal.fire('Error', 'Duplicates are not allowed', 'warning');
    //  return false;
    //}

    let obj = new bmRequest();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.topic = this.objBMRequest.topic;
    obj.typeDescr = this.objBMRequest.typeDescr
    obj.reasonforBMSel = this.objBMRequest.reasonforBMSel;
    obj.impactArea = this.objBMRequest.impactArea;
    obj.targetPeerGeoArea = this.objBMRequest.targetPeerGeoArea;
    obj.targetBMIndtry = this.objBMRequest.targetBMIndtry;
    obj.expectedOutcomes = this.objBMRequest.expectedOutcomes;
    obj.comments = this.objBMRequest.comments;
    obj.status = (this.editID != null && this.editID != undefined) ? this.objBMRequest.status:'Draft';
    obj.incidentNo = '0';
    obj.prNumber = '0';
    obj.ownerPRNumber = '0';
    obj.tenantUno=this.tenantUno 
    obj.userUno = this.login_UserID;
    this.restBMApi.addEdiBMRequestMaster(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Item Saved.');
            setTimeout(() => {
              this.objOutgoingRequest = new outgoingBMRequest();
              this.spinner.hide();
              this.loadBMRequestMaster();
              this.modalRef.hide();
            }, 500);
           
          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
   
  }
 


  DeleteBMRequestMaster(data1: any) {
    
    let obj = new outgoingBMRequest();
    obj.id = data1.id;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno
    this.restBMApi.deleteBMRequestMaster(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Item Deleted Successfully.');
          this.spinner.hide();
          this.loadBMRequestMaster();
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }


       
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }

    else {
      this.updateBMRequestStatus(this.objStatusHistroy);
    }
  }
  updateBMRequestStatus(data1: any) {
    

   

    let obj = new bmRequestStatusHistroy();
    obj = data1;
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objStatusHistroy.comments) ? this.objStatusHistroy.comments:'';
    obj.status = this.objStatusHistroy.status;
    obj.userUno = this.login_UserID;
    obj.tenantUno = this.tenantUno;
    obj.flag = 'bmrequest';
    this.restBMApi.updateBMRequestStatus(obj)
      .subscribe(data => {

        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Status Updated.');
          setTimeout(() => {
            this.objOutgoingRequest = new outgoingBMRequest();
            this.spinner.hide();
            this.loadBMRequestMaster();
            this.modalRef.hide();
          }, 500);

        }
        else {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  getBMProgressTypeDD() {

    let inpValue = new benchmarkprogressmaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMProgressTypeDD(inpValue)
      .subscribe(data => {

        this.bmProgressTypeDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  Reset() {
    this.modalRef.hide();
    setTimeout(() => {
      this.objBMRequest = new bmRequest();
      this.pageAction = 'add';
    }, 300);


  }

  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.data.filter(a =>
        a.topic.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.typeDescr && a.typeDescr.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.reasonforBMSel && a.reasonforBMSel.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.impactArea && a.impactArea.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetPeerGeoArea && a.targetPeerGeoArea.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetBMIndtry && a.targetBMIndtry.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.expectedOutcomes && a.expectedOutcomes.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.status && a.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.comments && a.comments.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.data;
  }
}
